// Swap evidence and deployment verification are needed only for a swap action.
export const loadSwapNotificationActions = () => import('@/components/drawers/SwapDrawer/swap-skip');
